import AllCertifications from "./AllCertifications";

export default AllCertifications;
